import angular from 'angular';

module.exports = angular.module('common.directives.tel', [
  require('common/filters/tel'),
])
.directive('type', function typeTel(telFilter, formattedCursorPosition) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function link(scope, element, attrs, ngModel) {
      if (attrs.type !== 'tel' || !ngModel) return;

      // view -> model
      ngModel.$parsers.push((oldValue) => {
        var numbers = oldValue.toString().trim().replace(/\D/g, '');
        if (numbers[0] === '1') {
          numbers = numbers.slice(1);
        }
        numbers = numbers.slice(0,10);

        let newValue = telFilter(numbers);
        let oldCursorPosition = element[0].selectionStart;
        let newCursorPosition = formattedCursorPosition(oldCursorPosition, oldValue, newValue);

        element.val(newValue);
        ngModel.$setViewValue(newValue);
        ngModel.$commitViewValue(newValue);
        element[0].setSelectionRange(newCursorPosition, newCursorPosition);

        return numbers;
      });

      // model -> view
      ngModel.$formatters.push((value) => {
        if (!value) return;

        return telFilter(value.toString().replace(/^\+?1\s*/, ''));
      });

      // validate the phone number (validation will be used by the form that
      // contains the <input type="tel"> element)
      ngModel.$validators.validPhoneNumberPattern = (value) => {
        return !value || /\d{3}[2-9]\d{6}/.test(value);
      };
    },
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/tel.js
 **/